import { render, staticRenderFns } from "./SmsDialog.vue?vue&type=template&id=4b1a75f4&scoped=true"
import script from "./SmsDialog.vue?vue&type=script&lang=js"
export * from "./SmsDialog.vue?vue&type=script&lang=js"
import style0 from "./SmsDialog.vue?vue&type=style&index=0&id=4b1a75f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a75f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1a75f4')) {
      api.createRecord('4b1a75f4', component.options)
    } else {
      api.reload('4b1a75f4', component.options)
    }
    module.hot.accept("./SmsDialog.vue?vue&type=template&id=4b1a75f4&scoped=true", function () {
      api.rerender('4b1a75f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/dialogs/SmsDialog.vue"
export default component.exports